import { PsychologistFreeScheduleStatus } from '../../SessionDebug';

/**
 * ¿Este slot de la agenda se pinta como un bloqueo ("ocupado") para la psicóloga?
 *
 * Todo slot que no estuviera disponible se pintaba como bloqueo, pero los marcados como vacaciones
 * (`OCCUPIED_BY_VACATION`) no lo son: son horarios de su configuración que caen dentro de un día off,
 * y las vacaciones ya se pintan aparte a partir de sus fechas (overlay gris de `CalendarCell`, ver
 * `useVacationBlockade`). Mostrarlos además como "Slot ocupado" ensuciaba la agenda, no se podían
 * desbloquear (el desbloqueo solo conoce los bloqueos manuales) y, al contar como ocupados, le
 * impedían agendar en un día off.
 */
export const isBlockingSlot = (slot: { status: string }): boolean =>
  slot.status !== PsychologistFreeScheduleStatus.AVAILABLE &&
  slot.status !== PsychologistFreeScheduleStatus.OCCUPIED_BY_VACATION;
